// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-checkbox-container[data-v-086640f0] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.text-checkbox-container[data-v-086640f0]:hover{\n  cursor: pointer;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
